import { ProviderAuthenticationError, ProviderCallsignNotFoundError, ProviderSessionExpiredError } from "./LookupServiceErrors";

export type QrzErrorConfig = {
  pattern: RegExp;
  error: typeof ProviderAuthenticationError | typeof ProviderCallsignNotFoundError | typeof ProviderSessionExpiredError;
  generateMessage: (param: string) => string;
};

export const QRZ_ERROR_CONFIGS: Record<string, QrzErrorConfig> = {
  invalidCredentials: {
    pattern: /^Username\/password incorrect$/,
    error: ProviderAuthenticationError,
    generateMessage: () => "Invalid username or password"
  },
  invalidSession: {
    // QRZ returns "Invalid session key" for a malformed/unknown key and
    // "Session Timeout" when a previously-valid session has expired. Both are
    // documented in the QRZ XML interface spec (https://www.qrz.com/XML/current_spec.html),
    // which shows "<Error>Session Timeout</Error>" verbatim and instructs
    // clients to "be prepared to login again whenever indicated." The spec says
    // session keys "have no guaranteed lifetime"; in practice users report them
    // expiring at 0Z (00:00 UTC), which surfaces as "Session Timeout" on the
    // first lookup after the rollover. Either way the session is unusable, so we
    // map both to a session-expired error to trigger re-auth + retry. Matched
    // case-insensitively for safety. Note: QRZ's separate "Connection refused"
    // error (a ~24h service denial) intentionally does NOT match here, so we
    // don't re-auth against a server that is refusing the user.
    pattern: /^(Invalid session key|Session Timeout)$/i,
    error: ProviderSessionExpiredError,
    generateMessage: () => "Session key is invalid or has expired"
  },
  notFound: {
    pattern: /^Not found: (.+)$/,
    error: ProviderCallsignNotFoundError,
    generateMessage: (callsign: string) => `Callsign ${callsign} not found`
  }
} as const; 